/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LabelEntityType {
    Base = '0',
    Ticket = 1,
    Mission = 2,
    Issue = 3,
}
